import { render } from "./TaskList.vue?vue&type=template&id=45b6c1dd&scoped=true&ts=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=45b6c1dd&scoped=true&lang=css"
import "./TaskList.vue?vue&type=style&index=1&id=45b6c1dd&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b6c1dd"]])

export default __exports__